<template>
  <div style="height:93%">
    <div slot="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/orders/orderList' }"
          >{{$t('laund.laund1')}}</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{$t('router.router8')}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="page-container">
      <div>
        <div style="width: 550px; margin: auto">
          <div style="margin: 20px auto; width: 100px; text-align: center">
            <span style="font-size: 20px">{{$t('router.router8')}}</span>
          </div>
          <el-form
            :model="personalInfo"
            ref="editForm"
            label-width="180px"
            :rules="formRules"
          >
            <el-form-item :label="$t('logLogin.creatorName')" prop="userName">
              <span>
                {{ personalInfo.userName }}
              </span>
            </el-form-item>
            <el-form-item :label="$t('createOrder.createOrder29')" prop="realName">
              <el-input
                v-model="personalInfo.realName"
                style="width: 300px"
                size="medium"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('accountInformation.accountInformation2')" prop="companyName">
              <el-input
                size="medium"
                v-model="personalInfo.companyName"
                style="width: 300px"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('accountInformation.accountInformation6')">
              <v-distpicker
                :province="addressSelect.province"
                :city="addressSelect.city"
                :area="addressSelect.area"
                @selected="onSelected"
              ></v-distpicker>
            </el-form-item>
            <el-form-item :label="$t('accountInformation.accountInformation7')">
              <el-switch
                inactive-value="0"
                active-value="1"
                v-model="personalInfo.autoDeductMoney"
                active-color="#13ce66"
                inactive-color="#909399"
              >
              </el-switch>

            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer" style="text-align: center">
            <el-button type="primary" @click="editSave()">{{$t('baoc')}}</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// npm install v-distpicker --save
export default {
  data() {
    return {
      formRules: {
        realName: [{ max: 10, message: this.$t('accountInformation.accountInformation10'), trigger: "blur" }],
        companyName: [
          { max: 20, message: this.$t('accountInformation.accountInformation11'), trigger: "blur" },
        ],
      },
      personalInfo: {
        userName: "",
        realName: "",
        companyName: "",
        address: "",
        autoDeductMoney: 0,
      },
      addressSelect: { province: "", city: "", area: "" },
    };
  },
  methods: {
    // 选择最后一项时触发事件
    onSelected(data) {
      if (data.area.code) {
        this.personalInfo.address =
          data.province.value + "," + data.city.value + "," + data.area.value;
      } else {
        this.personalInfo.address = "";
      }
    },
    editSave() {
      console.log(this.personalInfo);
      this.$refs["editForm"].validate(async (valid) => {
        if (valid) {
          const { data: res } = await this.$http.post(
            "admin/modifyInformation",
            this.personalInfo
          );
          if (res.code == 200) {
            this.$message({
              message: res.message,
              type: "success",
            });
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        }
      });
    },
    async getUserInfo() {
      const { data: res } = await this.$http.get("customer/getCustomerInfo");
      if (res.code == 200) {
        console.log(res);
        this.personalInfo.userName = res.data.userName;
        this.personalInfo.realName = res.data.realName;
        this.personalInfo.companyName = res.data.companyName;
        let addr = res.data.address;
        if (addr) {
          let addrs = addr.split(",");
          console.log(addrs);
          this.addressSelect.province = addrs[0];
          this.addressSelect.city = addrs[1];
          this.addressSelect.area = addrs[2];
        }
        this.personalInfo.autoDeductMoney = res.data.autoDeductMoney;
      } else {
        this.$message({
          message: res.message,
          type: "error",
        });
      }
    },
  },
  created() {
    this.getUserInfo();
  },
};
</script>